import _ from 'lodash';
import subscriptionPlanService from './subscriptionPlan.service';

export const HOME_PAGE = '/home';
export const HUB_STREAM_PAGE = '/hub/streams';
export const HUB_SEARCH_PAGE = '/hub/search';
export const DETAILED_HUB_SEARCH_PAGE = '/hub/search/:page';

export const STREAM_PAGE = '/streams/:id';
export const STREAM_SEARCH_PAGE = '/streams/:id/search';
export const STREAM_DETAILED_SEARCH_PAGE = '/streams/:id/search/:page';
export const GROUP_PAGE = '/groups/:id';

export const COLLECTIONS_PAGE = '/collections';
export const COLLECTIONS_UNCATEGORIZED = '/collections/uncategorized';
export const COLLECTION_PAGE = '/collections/:id';
export const COLLECTION_SECTION_PAGE = '/collections/:id/sections/:section';
export const COLLECTION_FOLEDER_PAGE = '/collections/folder/:id';

export const CONTACTS_ROOT_PATH = '/rolodex';
export const CONTACTS_PAGE = '/rolodex/contacts';
export const CONTACT_PAGE = '/rolodex/contacts/:id';
export const CONTACT_LISTS_PAGE = '/rolodex/contact_list';
export const CONTACT_LIST_PAGE = '/rolodex/contact_list/:id';

export const SEARCH_PAGE = '/search';
export const DETAILED_SEARCH_PAGE = '/search/:page';

export const CONVERSATIONS_PAGE = '/conversations';
export const CONVERSATION_PAGE = '/conversations/:id';

export const EDIT_CONVERSATION_PAGE = '/conversations/:id/edit';
export const EDIT_CONVERSATION_SECTION_PAGE = '/conversations/:id/sections/:section/edit';

export const REPORTS_PAGE = '/reports';
export const DISCOVERY_REPORT_PAGE = '/reports/discovery';
export const ENGAGEMENT_REPORT_PAGE = '/reports/engagement';
export const PERFORMANCE_REPORT_PAGE = '/reports/performance';

export const ENGAGE_PAGE = '/engage';
export const CHAT_USER_PAGE = '/engage/:id';

export const SETTINGS_USER_MANAGEMENT_PAGE = '/settings/user-management';
export const SETTINGS_ACCOUNT_MANAGEMENT_PAGE = '/settings/account-management';
export const SETTINGS_STREAM_ACCESS_MANAGEMENT_PAGE = '/settings/stream-access-management';
export const SETTINGS_DATASOURCE_MANAGEMENT_PAGE = '/settings/data-sources';
export const SETTINGS_FLITEVIEW_PAGE = '/settings/fliteview';
export const SETTINGS_PROMOTE_PAGE = '/settings/promote-content';
export const SETTINGS_INTEGRATIONS_PAGE = '/settings/integrations';
export const SETTINGS_CUSTOM_FIELDS_PAGE = '/settings/custom_fields';
export const SETTINGS_DISTRIBUTION_LISTS_PAGE = '/settings/distribution_lists';
export const SETTINGS_CONTACT_LISTS_PAGE = '/settings/contact_list';
export const SETTINGS_EMAIL_TEMPLATES_PAGE = '/settings/email-template';
export const SETTINGS_NOTIFICATIONS_PAGE = '/settings/notifications';
export const SETTINGS_NDA_TEMPLATES_PAGE = '/settings/nda-templates';
export const SETTINGS_PRIVACY_POLICY_CONTROL_PAGE = '/settings/privacy-policy-control';
export const SETTINGS_PAYMENT_HISTORY = '/settings/payment-history';

const routePermissions = {
  [HOME_PAGE]: ['hub.access'],
  [HUB_STREAM_PAGE]: ['hub.access'],
  [HUB_SEARCH_PAGE]: ['hub.access'],
  [HUB_SEARCH_PAGE]: ['hub.access'],
  [DETAILED_HUB_SEARCH_PAGE]: ['hub.access'],
  [STREAM_PAGE]: ['hub.access'],
  [STREAM_SEARCH_PAGE]: ['hub.access'],
  [STREAM_DETAILED_SEARCH_PAGE]: ['hub.access'],
  [GROUP_PAGE]: ['hub.access'],
  [COLLECTIONS_PAGE]: ['collection.access'],
  [COLLECTIONS_UNCATEGORIZED]: ['collection.access'],
  [COLLECTION_PAGE]: ['collection.access'],
  [COLLECTION_SECTION_PAGE]: ['collection.access'],
  [COLLECTION_FOLEDER_PAGE]: ['collection.access'],
  [CONTACTS_ROOT_PATH]: ['contact.access'],
  [CONTACTS_PAGE]: ['contact.access'],
  [CONTACT_PAGE]: ['contact.access'],
  [CONTACT_LISTS_PAGE]: ['contact.access'],
  [CONTACT_LIST_PAGE]: ['contact.access'],
  [SEARCH_PAGE]: ['search.access'],
  [DETAILED_SEARCH_PAGE]: ['search.access'],
  [CONVERSATIONS_PAGE]: ['conversation.access'],
  [CONVERSATION_PAGE]: ['conversation.access'],
  [EDIT_CONVERSATION_PAGE]: ['conversation.access'],
  [EDIT_CONVERSATION_SECTION_PAGE]: ['conversation.access'],
  [REPORTS_PAGE]: ['report.access'],
  [DISCOVERY_REPORT_PAGE]: ['report.access'],
  [ENGAGEMENT_REPORT_PAGE]: ['report.access'],
  [PERFORMANCE_REPORT_PAGE]: ['report.access'],
  [SETTINGS_USER_MANAGEMENT_PAGE]: ['settingsManagement.userManagement'],
  [SETTINGS_ACCOUNT_MANAGEMENT_PAGE]: ['settingsManagement.accountManagement'],
  [SETTINGS_STREAM_ACCESS_MANAGEMENT_PAGE]: ['hub.access', 'hub.create'],
  [SETTINGS_DATASOURCE_MANAGEMENT_PAGE]: ['hub.access', 'hub.create', 'settingsManagement.datasourceManagement'],
  [SETTINGS_FLITEVIEW_PAGE]: ['settingsManagement.promoteSettings'],
  [SETTINGS_PROMOTE_PAGE]: ['settingsManagement.accountManagement'],
  [SETTINGS_INTEGRATIONS_PAGE]: ['settingsManagement.integrations'],
  [SETTINGS_CUSTOM_FIELDS_PAGE]: ['settingsManagement.customFields'],
  [SETTINGS_DISTRIBUTION_LISTS_PAGE]: ['contact.access', 'contact.create'],
  [SETTINGS_CONTACT_LISTS_PAGE]: ['contact.access', 'contact.create'],
  [SETTINGS_EMAIL_TEMPLATES_PAGE]: ['settingsManagement.emailTemplates'],
  [SETTINGS_NOTIFICATIONS_PAGE]: ['settingsManagement.notifications'],
  [SETTINGS_NDA_TEMPLATES_PAGE]: ['settingsManagement.ndaTemplates'],
  [SETTINGS_PRIVACY_POLICY_CONTROL_PAGE]: ['settingsManagement.privacyPolicyControl'],
  [ENGAGE_PAGE]: ['engage.access'],
  [CHAT_USER_PAGE]: ['engage.access'],
  [SETTINGS_PAYMENT_HISTORY]: ['billing.accessInvoice']
}
export default class userRoleService {

  static initialise(user, account) {
    this.userRole = user.userRoles ? user.userRoles[0] : {};
    this.account = account;
  }

  static isInitialized() {
    return !!this.userRole && !!this.account;
  }

  static canAccessHub() {
    if (!subscriptionPlanService.canAccessHub()) {
      return false;
    }

    return _.get(this.userRole, 'hub.access', false);
  }

  static canCreateStream() {
    if (!subscriptionPlanService.canAccessHub()) {
      return false;
    }

    return _.get(this.userRole, 'hub.access', false) && _.get(this.userRole, 'hub.create', false);
  }

  static canCreateAsset() {
    if (!subscriptionPlanService.canCreateAsset()) {
      return false;
    }

    return _.get(this.userRole, 'hub.create', false) || _.get(this.userRole, 'collection.create', false);
  }

  static canAccessContentMap() {
    if (!subscriptionPlanService.canAccessContentMap()) {
      return false;
    }

    return _.get(this.userRole, 'hub.access', false);
  }

  static canCloneHub() {
    if (!subscriptionPlanService.canCloneHub()) {
      return false;
    }

    return _.get(this.userRole, 'hub.access', false) && _.get(this.userRole, 'hub.edit', false);
  }

  static canEditLayout() {

    if (!subscriptionPlanService.canAccessHub()) {
      return false;
    }
    return _.get(this.userRole, 'hub.access', false) && _.get(this.userRole, 'hub.edit', false);
  }

  static canAccessCollection() {
    if (!subscriptionPlanService.canAccessCollection()) {
      return false;
    }

    return _.get(this.userRole, 'collection.access', false);
  }

  static canCreateCollection() {
    return _.get(this.userRole, 'collection.create', false);
  }

  static canShareCollection() {
    return _.get(this.userRole, 'collection.share', false);
  }

  static canAccessDealRoom() {
    if (!subscriptionPlanService.canAccessDealRoom()) {
      return false;
    }

    return _.get(this.userRole, 'dealRoom.access', false);
  }

  static canCreateDealRoom() {
    return _.get(this.userRole, 'dealRoom.create', false);
  }

  static canCollaborateDealRoom() {
    return _.get(this.userRole, 'dealRoom.collaborate', false);
  }

  static canCollaborateCollection() {
    if (!subscriptionPlanService.canColloborateCollection()) {
      return false;
    }

    return _.get(this.userRole, 'collection.collaborate', false);
  }

  static canAccessReport() {
    if (!subscriptionPlanService.canAccessReports()) {
      return false;
    }

    return _.get(this.userRole, 'report.access', false);
  }

  static canDownloadReport() {
    return _.get(this.userRole, 'report.download', false);
  }

  static canDownload() {
    return _.get(this.userRole, 'asset.download', false);
  }

  static canRestrictAllReports() {
    return _.get(this.userRole, 'report.restricted', false);
  }

  static canAccessContact() {
    return _.get(this.userRole, 'contact.access', false);
  }

  static canCreateContact() {
    return _.get(this.userRole, 'contact.create', false);
  }

  static canAccessSearch() {
    return _.get(this.userRole, 'search.access', false);
  }

  static canShare() {
    if (!subscriptionPlanService.canShare()) {
      return false;
    }

    return _.get(this.userRole, 'share.access', false);
  }

  static canAccessConversation() {
    if (!subscriptionPlanService.canShare()) {
      return false;
    }

    return _.get(this.userRole, 'conversation.access', false);
  }

  static canAccessUserManagement() {
    return _.get(this.userRole, 'settingsManagement.userManagement', false)
  }

  static canAccessAccountManagement() {
    return _.get(this.userRole, 'settingsManagement.accountManagement', false)
  }

  static canAccessDataSource() {
    return this.canAccessHub() && this.canCreateStream() && _.get(this.userRole, 'settingsManagement.datasourceManagement', false);
  }

  static canAccessStreamAccessManagement() {
    return _.get(this.userRole, 'settingsManagement.streamAccessManagement', false);
  }

  static canAccessPromoteSettings() {
    return this.canShare() && _.get(this.userRole, 'settingsManagement.promoteSettings', false);
  }

  static canAccessIntegrations() {
    if (!subscriptionPlanService.canShare()) {
      return false;
    }

    return _.get(this.userRole, 'settingsManagement.integrations', false);
  }

  static canAccessCustomFields() {
    if (!subscriptionPlanService.canAccessHub()) {
      return false;
    }

    return _.get(this.userRole, 'settingsManagement.customFields', false);
  }

  static canAccessEmailTemplates() {
    return this.canShare() && _.get(this.userRole, 'settingsManagement.emailTemplates', false);
  }

  static canAccessNotifications() {
    return _.get(this.userRole, 'settingsManagement.notifications', false);
  }

  static canAccessNdaTemplates() {
    return this.canShare() && _.get(this.userRole, 'settingsManagement.ndaTemplates', false);
  }

  static canAccessPrivacyPolicyControl() {
    return this.canShare() && _.get(this.userRole, 'settingsManagement.privacyPolicyControl', false);
  }

  static canAccessReferral(account) {
    return _.get(account, 'referralEnabled', false);
  }

  static canAccessEngage(account) {

    if (!account) {
      account = this.account;
    }

    if (!subscriptionPlanService.canAccessEngage()) {
      return false;
    }

    return _.get(account, 'engageEnabled', false) && _.get(this.userRole, 'engage.access', false);
  }

  static canAccessGlobalRecipients() {
    return _.get(this.userRole, 'engage.globalEngage', false);
  }

  static isEngageViewOnly() {
    return _.get(this.userRole, 'engage.viewOnly', false);
  }

  static canBlockRecipient() {
    return _.get(this.userRole, 'engage.block', false);
  }

  static canAccessDealInsights(account) {
    if (!subscriptionPlanService.canAccessDealInsights()) {
      return false;
    }

    return _.get(account, 'dealInsightsEnabled', false);
  }

  static canAccessDistributionLists() {
    return this.canShare() && this.canAccessContact() && this.canCreateContact();
  }


  static canAccessStarterRole(account) {
    return _.get(account, 'starterRoleEnabled', false);
  }

  static requirePermission(path, profile, account) {
    var userRole = profile.userRoles ? profile.userRoles[0] : {};
    var accountRole = account ? account : {};
    var roles = { ...userRole, accountRole }
    var permissions = routePermissions[path];

    if (!permissions) {
      return true
    }

    var access = true;

    permissions.forEach(item => {
      access = access && _.get(roles, item, false)
    });

    return access;
  }

  static canAccessPaymentHistory(account) {
    return _.get(account, 'billingEnabled', false) && _.get(this.userRole, 'billing.accessInvoice', false);
  }

  //Coaching
  static canAccessCoaching() {
    const coachingEnabled = _.get(this.account, 'coachingEnabled', false);
    if (!coachingEnabled) {
      return false;
    }

    return _.get(this.userRole, 'coaching.access', false);
  }
  
  static canCreateCourse() {
    const coachingEnabled = _.get(this.account, 'coachingEnabled', false);
    if (!coachingEnabled) {
      return false;
    }

    return _.get(this.userRole, 'coaching.create', false);
  }
  
  static canAssignCourses() {
    const coachingEnabled = _.get(this.account, 'coachingEnabled', false);
    if (!coachingEnabled) {
      return false;
    }

    return _.get(this.userRole, 'coaching.assign', false);
  }

  static canAccessCoachingReport() {
    const coachingEnabled = _.get(this.account, 'coachingEnabled', false);
    if (!coachingEnabled) {
      return false;
    }
    
    return _.get(this.userRole, 'coaching.reports', false);
  }
  
  static canMarkAsTemplate() {
    return _.get(this.userRole, 'collection.template', false);
  }
}